const IntegrationType = Object.freeze({
    NEO: 'NEO INTEGRATION',
    CREDIT_PULL: 'CREDIT PULL',
    UNDERWRITING: 'UNDERWRITING',
});

export default IntegrationType;
